export default __webpack_public_path__ + "static/media/cloud-computing.e058658f.svg";